export const CAROUSEL_ACTIVE_ITEM = 2;
